import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.AdressModal.title',
    defaultMessage: 'Add Address',
  },
  subTitle: {
    id: 'src.pages.AdressModal.subTitle',
    defaultMessage: 'Fill in the form below to manually add this address.',
  },
  street: {
    id: 'src.pages.AdressModal.street',
    defaultMessage: 'Street #',
  },
  streetName: {
    id: 'src.pages.AdressModal.streetName',
    defaultMessage: 'Street Name',
  },
  city: {
    id: 'src.pages.AdressModal.city',
    defaultMessage: 'City',
  },
  country: {
    id: 'src.pages.AdressModal.country',
    defaultMessage: 'Country',
  },
  province: {
    id: 'src.pages.AdressModal.province',
    defaultMessage: 'Province',
  },
  state: {
    id: 'src.pages.AdressModal.state',
    defaultMessage: 'State',
  },
  postalCode: {
    id: 'src.pages.AdressModal.postalCode',
    defaultMessage: 'Postal Code',
  },
  zipCode: {
    id: 'src.pages.AdressModal.zipCode',
    defaultMessage: 'Zip Code',
  },
  addIncident: {
    id: 'src.pages.AdressModal.addIncident',
    defaultMessage: 'Add the incident location',
  },
  fillInTheForm: {
    id: 'src.pages.AdressModal.fillInTheForm',
    defaultMessage: 'Fill in the form bellow with address, intersection, or highway closest to where the incident occurred.',
  },
  saveAddress: {
    id: 'src.pages.AdressModal.saveAddress',
    defaultMessage: 'Save address',
  },
  cancel: {
    id: 'src.pages.AdressModal.cancel',
    defaultMessage: 'Cancel',
  },
});
